import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FluidsInfusionAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-fluids-infusion-slot',
    templateUrl: './fluids-infusion-slot.component.html',
    styleUrl: './fluids-infusion-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsInfusionSlotComponent implements SheetSlotComponentBase {

	action!: FluidsInfusionAction;
	value!: string | null;

	@Input('action') set updateAction(action: FluidsInfusionAction | null) {
		this.action = action as FluidsInfusionAction;
		this.value = this.action.rate?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}